<template>
  <div>
    <div class="main-content" v-if="documento">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ documento.nome }}
                <span class="badge ml-1" :class="'badge-light-' + statusDocumento.cor">{{ statusDocumento.texto }}</span>
              </div>
            </div>
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-md-4">
                  <small class="text-muted d-block">Enviado em</small>
                  {{ formatarData(documento.created_at) }}
                </div>
                <div class="col-md-8">
                  <small class="text-muted d-block">Hash SHA-256 do original</small>
                  <code class="hash">{{ documento.hash_original }}</code>
                </div>
              </div>

              <div class="assinar p-2 mb-2">
                <div class="form-row align-items-end">
                  <div class="form-group col-md-4 mb-0">
                    <label for="cpf">CPF do signatário (opcional):</label>
                    <input id="cpf" type="text" class="form-control" v-mask="'999.999.999-99'" v-model="cpf"
                      placeholder="Restringe a assinatura a este CPF" />
                  </div>
                  <div class="form-group col-md-8 mb-0 text-right">
                    <button type="button" class="btn btn-outline-primary mr-1" :disabled="assinando || cancelado"
                      @click="novaSolicitacao(false)">
                      <i class="fa fa-user-plus"></i> Adicionar signatário
                    </button>
                    <button type="button" class="btn btn-primary" :disabled="assinando || cancelado"
                      @click="novaSolicitacao(true)">
                      <i class="fa fa-signature"></i>
                      {{ assinando ? "Aguardando autorização no app..." : "Iniciar assinatura" }}
                    </button>
                  </div>
                </div>
                <small class="text-muted d-block mt-1">
                  <strong>Iniciar assinatura</strong> abre agora a janela para quem está na tela escolher o certificado
                  em nuvem e aprovar no app. <strong>Adicionar signatário</strong> só cria a linha, para enviar o link
                  por e-mail ou copiar e mandar para a pessoa.
                </small>
              </div>

              <h5 class="mt-2">Assinaturas</h5>
              <div class="table-responsive">
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th>Titular</th>
                      <th>Provedor</th>
                      <th>CPF</th>
                      <th>Autoridade certificadora</th>
                      <th>Status</th>
                      <th>Assinado em</th>
                      <th class="text-right">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!documento.assinaturas.length">
                      <td colspan="7" class="text-muted text-center">Nenhuma assinatura ainda.</td>
                    </tr>
                    <tr v-for="assinatura in documento.assinaturas" :key="assinatura.uuid">
                      <td>
                        {{ (assinatura.certificado && assinatura.certificado.titular) || assinatura.nome || "-" }}
                        <small v-if="assinatura.email" class="d-block text-muted">
                          {{ assinatura.email }}
                          <span v-if="assinatura.email_erro" class="text-danger">· {{ assinatura.email_erro }}</span>
                          <span v-else-if="assinatura.email_enviado_em">
                            · e-mail enviado em {{ formatarData(assinatura.email_enviado_em) }}
                          </span>
                          <span v-else-if="emAberto(assinatura)">· e-mail na fila de envio</span>
                          <span v-if="assinatura.email_aberto_em"
                            title="Indício: alguns leitores (ex.: Apple Mail) abrem sozinhos e outros (ex.: Outlook) bloqueiam a imagem de rastreio">
                            · aberto em {{ formatarData(assinatura.email_aberto_em) }}
                          </span>
                        </small>
                        <small v-if="assinatura.visualizado_em" class="d-block text-success">
                          <i class="fa fa-eye"></i> visualizou o documento em {{ formatarData(assinatura.visualizado_em) }}
                        </small>
                      </td>
                      <td>{{ assinatura.clearance || "-" }}</td>
                      <td>{{ formatarCpf((assinatura.certificado && assinatura.certificado.cpf) || assinatura.cpf_esperado) || "-" }}</td>
                      <td>{{ (assinatura.certificado && assinatura.certificado.emissor) || "-" }}</td>
                      <td>
                        <span class="badge" :class="'badge-light-' + rotuloAssinatura(assinatura.status).cor">
                          {{ rotuloAssinatura(assinatura.status).texto }}
                        </span>
                        <small v-if="assinatura.erro" class="d-block text-danger">{{ assinatura.erro }}</small>
                      </td>
                      <td>{{ formatarData(assinatura.assinado_em) || "-" }}</td>
                      <td class="text-right acoes">
                        <button v-if="podeAssinar(assinatura)" type="button" class="btn btn-sm btn-flat-primary"
                          :disabled="assinando" :title="assinatura.status === 'pendente' ? 'Assinar agora' : 'Reiniciar assinatura'"
                          @click="abrirPopup(assinatura.uuid)">
                          <i class="fa" :class="assinatura.status === 'pendente' ? 'fa-signature' : 'fa-redo'"></i>
                        </button>
                        <button type="button" class="btn btn-sm btn-flat-secondary" title="Copiar link da página de assinatura"
                          @click="copiarLink(assinatura)">
                          <i class="fa fa-link"></i>
                        </button>
                        <button v-if="emAberto(assinatura)" type="button" class="btn btn-sm btn-flat-secondary"
                          title="Enviar link por e-mail" @click="abrirEmail(assinatura)">
                          <i class="fa fa-envelope"></i>
                        </button>
                        <button v-if="podeExcluir(assinatura)" type="button" class="btn btn-sm btn-flat-danger"
                          title="Excluir assinatura" @click="excluir(assinatura)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="block text-right mt-2">
                <router-link to="/documentos" class="btn btn-back">
                  <i class="fa fa-arrow-left"></i> Voltar
                </router-link>
                <button type="button" class="btn btn-add ml-1" @click="baixar('original')">
                  <i class="fa fa-file-pdf"></i> Baixar original
                </button>
                <button v-if="documento.possui_assinado" type="button" class="btn btn-add ml-1" @click="baixar('assinado')">
                  <i class="fa fa-file-signature"></i> Baixar assinado
                </button>
                <a v-if="documento.possui_assinado" href="https://validar.iti.gov.br/" target="_blank" rel="noopener"
                  class="btn btn-link ml-1">Validar no ITI</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="modalEmail" title="Enviar link por e-mail" ok-title="Enviar" cancel-title="Cancelar"
      :ok-disabled="enviandoEmail" @ok.prevent="enviarEmail">
      <div class="form-group">
        <label for="emailSignatario"><span class="required">*</span> E-mail do signatário:</label>
        <input id="emailSignatario" type="email" class="form-control" v-model="formEmail.email" placeholder="pessoa@empresa.com.br" />
      </div>
      <div class="form-group mb-0">
        <label for="nomeSignatario">Nome:</label>
        <input id="nomeSignatario" type="text" class="form-control" v-model="formEmail.nome" placeholder="Usado na saudação do e-mail" />
      </div>
      <small class="text-muted d-block mt-1">
        A pessoa recebe um link para ver o documento e clicar em "Assinar documento".
      </small>
    </b-modal>
  </div>
</template>

<script>
import { BModal } from "bootstrap-vue";
import {
  STATUS_ASSINATURA,
  STATUS_DOCUMENTO,
  baixarArquivo,
  formatarCpf,
  formatarData,
} from "../../utils/assinatura";

const STATUS_FINAIS = ["assinado", "erro"];
const REINICIAVEIS = ["pendente", "aguardando_autorizacao", "erro"];
const EM_ABERTO = ["pendente", "aguardando_autorizacao", "erro"];

export default {
  components: {
    BModal,
  },
  data() {
    return {
      documento: null,
      cpf: "",
      assinando: false,
      popup: null,
      uuidEmAndamento: null,
      intervalo: null,
      formEmail: { uuid: null, email: "", nome: "" },
      enviandoEmail: false,
    };
  },
  computed: {
    statusDocumento() {
      return STATUS_DOCUMENTO[this.documento.status] || { texto: this.documento.status, cor: "secondary" };
    },
    cancelado() {
      return this.documento.status === "cancelado";
    },
  },
  methods: {
    formatarData,
    formatarCpf,
    rotuloAssinatura(status) {
      return STATUS_ASSINATURA[status] || { texto: status, cor: "secondary" };
    },
    podeAssinar(assinatura) {
      return !this.cancelado && REINICIAVEIS.includes(assinatura.status);
    },
    emAberto(assinatura) {
      return EM_ABERTO.includes(assinatura.status);
    },
    podeExcluir(assinatura) {
      return !["assinado", "assinando"].includes(assinatura.status);
    },
    carregar() {
      const self = this;
      return axios
        .get(self.$store.state.api + "documentos/" + self.$route.params.id)
        .then((response) => {
          self.documento = response.data;
        })
        .catch((error) => {
          self.$message(null, error.response ? error.response.data : error, "error");
        });
    },
    // Abre a janela já no clique (gesto do usuário) - aberta depois de um
    // await ela seria barrada pelo bloqueador de pop-ups.
    abrirJanela() {
      const janela = window.open("", "ares-assinatura", "width=600,height=750");
      if (!janela) {
        this.$message(null, "Permita pop-ups para este site para assinar.", "error");
        return null;
      }
      janela.document.write("<p style='font-family:sans-serif;padding:24px'>Preparando a assinatura...</p>");
      return janela;
    },
    acompanharPopup(janela, uuid, url) {
      this.popup = janela;
      this.uuidEmAndamento = uuid;
      this.assinando = true;
      janela.location = url;
      this.acompanhar();
    },
    novaSolicitacao(abrirAgora) {
      const self = this;
      const janela = abrirAgora ? self.abrirJanela() : null;
      if (abrirAgora && !janela) return;

      axios
        .post(self.$store.state.api + "documentos/" + self.documento.id + "/assinaturas", {
          cpf: self.cpf || null,
          // Adicionar signatário sempre cria outra linha; iniciar reaproveita
          novo: !abrirAgora,
        })
        .then((response) => {
          if (abrirAgora) {
            self.acompanharPopup(janela, response.data.uuid, response.data.url);
          } else {
            self.$message("Sucesso", "Signatário adicionado. Envie o link por e-mail ou copie para mandar.", "success");
            self.cpf = "";
            self.carregar();
          }
        })
        .catch((error) => {
          if (janela) janela.close();
          self.$message(null, error.response ? error.response.data : error, "error");
        });
    },
    abrirPopup(uuid) {
      const janela = this.abrirJanela();
      if (!janela) return;
      this.acompanharPopup(janela, uuid, this.$store.state.url + "assinar/" + uuid);
    },
    // Reserva para quando a mensagem do popup não chega (ex.: popup fechado
    // antes do retorno): consulta o status até ele ficar final.
    acompanhar() {
      const self = this;
      clearInterval(self.intervalo);

      self.intervalo = setInterval(() => {
        axios
          .get(self.$store.state.api + "assinaturas/" + self.uuidEmAndamento)
          .then((response) => {
            const finalizado = STATUS_FINAIS.includes(response.data.status);
            if (finalizado || (self.popup && self.popup.closed)) {
              self.finalizar(response.data.status, response.data.erro);
            }
          })
          .catch(() => {});
      }, 3000);
    },
    finalizar(status, erro) {
      if (!this.assinando) return;

      clearInterval(this.intervalo);
      this.assinando = false;
      this.uuidEmAndamento = null;

      if (status === "assinado") {
        this.$message("Sucesso", "Documento assinado.", "success");
      } else if (status === "erro") {
        this.$message(null, erro || "Não foi possível assinar o documento.", "error");
      }

      this.carregar();
    },
    receberMensagem(evento) {
      const dados = evento.data || {};
      if (dados.tipo === "ares-sign:assinatura" && dados.uuid && dados.uuid === this.uuidEmAndamento) {
        this.finalizar(dados.status, dados.mensagem);
      }
    },
    copiarLink(assinatura) {
      const self = this;
      const link = assinatura.url_publica;
      const avisar = () => self.$message("Copiado", "Link da página de assinatura copiado.", "success");

      // clipboard só existe em contexto seguro (https/localhost)
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(link).then(avisar).catch(() => self.copiarManual(link, avisar));
      } else {
        self.copiarManual(link, avisar);
      }
    },
    copiarManual(texto, avisar) {
      const campo = document.createElement("textarea");
      campo.value = texto;
      campo.setAttribute("readonly", "");
      campo.style.position = "fixed";
      campo.style.opacity = "0";
      document.body.appendChild(campo);
      campo.select();
      const ok = document.execCommand("copy");
      campo.remove();
      ok ? avisar() : window.prompt("Copie o link:", texto);
    },
    abrirEmail(assinatura) {
      this.formEmail = { uuid: assinatura.uuid, email: assinatura.email || "", nome: assinatura.nome || "" };
      this.$refs.modalEmail.show();
    },
    enviarEmail() {
      const self = this;
      self.enviandoEmail = true;

      axios
        .post(self.$store.state.api + "assinaturas/" + self.formEmail.uuid + "/email", {
          email: self.formEmail.email,
          nome: self.formEmail.nome || null,
        })
        .then(() => {
          self.$message("Sucesso", "E-mail para " + self.formEmail.email + " colocado na fila de envio.", "success");
          self.$refs.modalEmail.hide();
          self.carregar();
          // O envio acontece em segundo plano: recarrega para mostrar o resultado
          setTimeout(() => self.carregar(), 8000);
        })
        .catch((error) => {
          const dados = error.response ? error.response.data : error;
          self.$message(null, (dados && dados.errors) || (dados && dados.message) || dados, "error");
        })
        .finally(() => {
          self.enviandoEmail = false;
        });
    },
    excluir(assinatura) {
      const self = this;
      const quem = (assinatura.certificado && assinatura.certificado.titular) || assinatura.nome || assinatura.email
        || formatarCpf(assinatura.cpf_esperado) || "esta assinatura";

      if (!window.confirm("Excluir a solicitação de assinatura de " + quem + "? O link enviado deixará de funcionar.")) {
        return;
      }

      axios
        .delete(self.$store.state.api + "assinaturas/" + assinatura.uuid)
        .then(() => {
          self.$message("Sucesso", "Assinatura excluída.", "success");
          self.carregar();
        })
        .catch((error) => {
          self.$message(null, error.response ? error.response.data : error, "error");
        });
    },
    baixar(versao) {
      const self = this;
      baixarArquivo(
        self.$store.state.api + "documentos/" + self.documento.id + "/download?versao=" + versao,
        self.documento.nome
      ).catch(() => {
        self.$message(null, "Não foi possível baixar o arquivo.", "error");
      });
    },
  },
  mounted() {
    window.addEventListener("message", this.receberMensagem);
    this.carregar();
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receberMensagem);
    clearInterval(this.intervalo);
  },
};
</script>

<style scoped>
.assinar {
  border: 1px dashed #d8d6de;
  border-radius: 6px;
}

.hash {
  word-break: break-all;
  font-size: 0.8rem;
}

.acoes {
  white-space: nowrap;
}

.acoes .btn {
  padding: 0.3rem 0.5rem;
}
</style>
